import { Box } from '@domain-group/suit-theme'

import OrderItem from './OrderItem'

import useImportProjectAdCopies, { AdCopyOrderItemModel } from '../../hooks/useImportProjectAdCopies'

const requestOptions = {
  include_order_item_ad_copies: true,
  include_order_item_campaign_id: true,
  include_order_item_service: true,
}

interface ProjectMediaProps {
  campaignId: number,
}

const ProjectAdCopies = (props: ProjectMediaProps) => {
  const { campaignId } = props

  const projectMediaPayload = useImportProjectAdCopies(campaignId, { requestOptions })
  const {
    adCopyOrderItems,
    hasAdCopyOrderItems,
  } = projectMediaPayload

  if (!hasAdCopyOrderItems) return null

  return (
    <Box flexDirection="column">
      {/*
       // @ts-expect-error TS18048 */}
      {adCopyOrderItems.map((orderItem: AdCopyOrderItemModel) => (
        <OrderItem key={orderItem.id} orderItem={orderItem} />
      ))}
    </Box>
  )
}

export default ProjectAdCopies
